import React, { useState, useRef, useEffect } from 'react';
import Button from '../../../../Button';
import { ReactComponent as CopySVG } from '../../../../../img/default-svg/copy.svg';
import { ReactComponent as CopySVGInex } from '../../../../../img/inex/copy.svg';
import { ReactComponent as CopySVGInsta } from '../../../../../img/instaXchange/copy.svg';
import { ReactComponent as CopySVGCoinera } from '../../../../../img/coinera/copy.svg';
import noCheckoutImgSVG from '../../../../../img/default-svg/no-checkout-image.svg';
import { ReactComponent as HelpCircleSVG } from '../../../../../img/default-svg/help-circle.svg';
import { Popover, Tabs, Checkbox, Tooltip, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import './style.scss';
import Highlight from 'react-highlight';
import { identity } from '../../../../../utils/getIdentity';
import { AppConfig } from '../../../../../config';

const { TabPane } = Tabs;

const copyIcon = {
  cpay: <CopySVG />,
  nfg: <CopySVG />,
  finvaro: <CopySVG />,
  clarnium: <CopySVG />,
  inex: <CopySVGInex />,
  insta: <CopySVGInsta />,
  coinera: <CopySVGCoinera />
}

const DetailedCheckout = ({ detailedCheckoutState, close, merchants, merchantId, isRecurring }) => {
  const location = window.location.href;
  const [clickIdFlag, setClickIdFlag] = useState(false);
  const [customDomainFlag, setCustomDomainFlag] = useState(false);
  const [clickIdData, setClickIdData] = useState('');
  const [showClickIdErrorMessage, setShowClickIdErrorMessage] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [activeSwitch, setActiveSwitch] = useState('link');
  const [amountAndFiatCurrencyFlag, setAmountAndFiatCurrencyFlag] = useState(false);
  const [amoundData, setAmoundData] = useState('');
  const [fiatCurrencyData, setFiatCurrencyData] = useState('');
  const [showAmoundDataMessage, setShowAmoundDataMessage] = useState(false);
  const [showFiatCurrencyDataMessage, setShowFiatCurrencyDataMessage] = useState(false);

  const { t } = useTranslation();
  const timer = useRef(null);
  const { organizationName, productName, type, description, identifier, image, cartName, name, contractId } =
    detailedCheckoutState;
  const isCustomDomain = merchants.filter(item => item._id === merchantId)[0].checkoutCustomUrl;

  const getCustomUrl = () => {
    const currentMerchant = merchants.filter(item => item._id === merchantId);

    if (currentMerchant[0].checkoutCustomUrl) {
      if (currentMerchant[0].checkoutCustomUrl.includes('https://')) {
        let url = currentMerchant[0].checkoutCustomUrl.slice(8);
        if (url.endsWith('/')) {
          url = url.replace(/\/+$/, '');
        }

        return `.${url}/`;
      } else if (currentMerchant[0].checkoutCustomUrl.includes('http://')) {
        let url = currentMerchant[0].checkoutCustomUrl.slice(7);
        if (url.endsWith('/')) {
          url = url.replace(/\/+$/, '');
        }
        return `.${url}/`;
      } else {
        let url = currentMerchant[0].checkoutCustomUrl;
        if (url.endsWith('/')) {
          url = url.replace(/\/+$/, '');
        }
        return `.${url}/`;
      }
    } else {
      return process.env.REACT_APP_URL;
    }
  };

  const checkoutLinkCPay = isRecurring && (location?.includes('demo') || location.includes('localhost'))
    ? 'https://recurring-billing-wallet-demo.gemewallet.com/'
    : isRecurring && location?.includes('stage')
    ? 'https://recurring-billing-wallet-stage.gemewallet.com/'
    : isRecurring
    ? 'https://recurring-billing.gemewallet.com/'
    : location.includes('demo') || location.includes('localhost')
      ? 'https://checkouts-geme-wallet-demo.gemewallet.com/'
      : location.includes('stage')
      ? 'https://checkouts-geme-wallet-stage.gemewallet.com/'
      : 'https://checkouts.gemewallet.com/';
  const checkoutLinkNFG = isRecurring ? 'https://recurring-billing.crypto-now.io/' : 'https://checkouts.crypto-now.io/';
  const checkoutLinkFinvaro = isRecurring ? 'https://recurring-billing.finvaro.com/' : 'https://checkouts.finvaro.com/';
  const checkoutLinkClarnium = isRecurring
    ? 'https://recurring-billing.clarnium.io/'
    : 'https://checkouts.clarnium.io/';
  const checkoutLinkInex = isRecurring
    ? 'https://recurring-billing.inexlatampay.com/'
    : 'https://checkouts.inexlatampay.com/';
  const checkoutLinkInsta = isRecurring
    ? 'https://recurring-billing.instaxgateway.com/'
    : 'https://checkouts.instaxgateway.com/';
  const checkoutLinkCoinera = isRecurring
    ? 'https://recurring-billing-coin.finera.com/'
    : 'https://checkouts-coin.finera.com/';

  const customDomain = `https://${isRecurring ? 'recurring-billing' : 'checkouts'}${getCustomUrl()}`;

  const checkoutLink = {
    cpay: `${!customDomainFlag ? checkoutLinkCPay : customDomain}`,
    nfg: checkoutLinkNFG,
    finvaro: checkoutLinkFinvaro,
    clarnium: checkoutLinkClarnium,
    inex: checkoutLinkInex,
    insta: checkoutLinkInsta,
    coinera: checkoutLinkCoinera
  };

  const contractIdForLink = contractId || '';

  //  const checkoutSaleLink = {
  //   cpay: 'sell-token-checkout',
  //   nfg: 'sale-token-checkout'
  //  } // temporary for sell-token-checkout, will delete later if it works properly

  const copyHandler = () => {
    navigator.clipboard.writeText(
      activeSwitch === 'link'
        ? `${checkoutLink[identity]}${
          isRecurring ? 'recurring-payment' : type === 'SaleToken' ? 'sell-token-checkout' : 'checkout'
        }/${isRecurring ? contractIdForLink : identifier}${clickIdFlag ? `?clickId=${clickIdData}` : ''}${
          clickIdFlag && amountAndFiatCurrencyFlag ? '&' : amountAndFiatCurrencyFlag ? '?' : ''
        }${amountAndFiatCurrencyFlag ? `amount=${amoundData}&fiatCurrency=${fiatCurrencyData}` : ''}`
        : activeSwitch === 'embed'
          ? `
    <div>
      <a class="buy-with-crypto"
        href="${checkoutLink[identity]}${
            isRecurring ? 'recurring-payment' : type === 'SaleToken' ? 'sell-token-checkout' : 'checkout'
          }/${isRecurring ? contractIdForLink : identifier}${clickIdFlag ? `?clickId=${clickIdData}` : ''}${
            clickIdFlag && amountAndFiatCurrencyFlag ? '&' : amountAndFiatCurrencyFlag ? '?' : ''
          }${amountAndFiatCurrencyFlag ? `amount=${amoundData}&fiatCurrency=${fiatCurrencyData}` : ''}"
      >
      Buy with Crypto
      </a>
    </div>
    `
          : `
    <iframe src="${checkoutLink[identity]}${
            isRecurring ? 'recurring-payment' : type === 'SaleToken' ? 'sell-token-checkout' : 'checkout'
          }/${isRecurring ? contractIdForLink : identifier}${clickIdFlag ? `?clickId=${clickIdData}` : ''}${
            clickIdFlag && amountAndFiatCurrencyFlag ? '&' : amountAndFiatCurrencyFlag ? '?' : ''
          }${
            amountAndFiatCurrencyFlag ? `amount=${amoundData}&fiatCurrency=${fiatCurrencyData}` : ''
          }" frameborder="0"></iframe>
    `
    );
    setShowPopover(true);
    timer.current = setTimeout(() => setShowPopover(false), 1000);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timer);
      timer.current = null;
    };
  });

  const validateClickId = clickId => {
    if (/[^a-zA-Z0-9\-_]/.test(clickId)) {
      setShowClickIdErrorMessage(true);
    } else {
      setClickIdData(clickId);
      setShowClickIdErrorMessage(false);
    }
  };

  const validateAmountData = e => {
    const input = e.target.value;

    if (input.trim() === '' || /^\d+(\.\d*)?$/.test(input)) {
      setAmoundData(input);
      setShowAmoundDataMessage(false);
    } else {
      setShowAmoundDataMessage(true);
    }
  };

  const validateFiatCurrencyData = fiatCurrency => {
    const allowedCurrencyCodes = ['AED', 'AUD', 'BRL', 'CNY', 'EUR', 'GBP', 'NGN', 'RUB', 'TRY', 'UAH', 'USD', 'USDC', 'USDT'];

    const sanitizedInput = fiatCurrency.toUpperCase();

    if (sanitizedInput !== '' && (!/^[A-Z]+$/.test(sanitizedInput) || !allowedCurrencyCodes.includes(sanitizedInput))) {
      setFiatCurrencyData(sanitizedInput);
      setShowFiatCurrencyDataMessage(true);
    } else {
      setFiatCurrencyData(sanitizedInput);
      setShowFiatCurrencyDataMessage(false);
    }
  };

  const callback = key => {
    setActiveSwitch(key);
  };

  const highlightedCode = `
  <div>
    <a class="buy-with-crypto"
      href="${checkoutLink[identity]}${
    isRecurring ? 'recurring-payment' : type === 'SaleToken' ? 'sell-token-checkout' : 'checkout'
  }/
      ${isRecurring ? contractIdForLink : identifier}${clickIdFlag ? `?clickId=${clickIdData}` : ''}${
    clickIdFlag && amountAndFiatCurrencyFlag ? '&' : amountAndFiatCurrencyFlag ? '?' : ''
  }${amountAndFiatCurrencyFlag ? `amount=${amoundData}&fiatCurrency=${fiatCurrencyData}` : ''}"
    >
    Buy with Crypto
    </a>
  </div>
  `;

  const highlightedCodeIFrame = `
  <iframe src="${checkoutLink[identity]}${
    isRecurring ? 'recurring-payment' : type === 'SaleToken' ? 'sell-token-checkout' : 'checkout'
  }/${isRecurring ? contractIdForLink : identifier}${clickIdFlag ? `?clickId=${clickIdData}` : ''}${
    clickIdFlag && amountAndFiatCurrencyFlag ? '&' : amountAndFiatCurrencyFlag ? '?' : ''
  }${
    amountAndFiatCurrencyFlag ? `amount=${amoundData}&fiatCurrency=${fiatCurrencyData}` : ''
  }" frameborder="0"></iframe>
  `;

  return (
    <div className="detailed-checkout">
      <div className={`detailed-checkout__info-container detailed-checkout__info-container-${identity}`}>
        <div className="detailed-checkout__info-image">
          <img src={image ? `${process.env.REACT_APP_API_URL}${image}` : noCheckoutImgSVG} alt="" />
        </div>
        <div className="detailed-checkout__info">
          <div className={`detailed-checkout__name detailed-checkout__name-${identity}`}>{organizationName || productName || cartName || name}</div>
          <div className="detailed-checkout__description">{description}</div>
        </div>
      </div>
      <div className={`detailed-checkout__notif detailed-checkout__notif-${identity}`}>{t('checkouts.linkShare')}</div>
      <div className={`detailed-checkout__switch-container detailed-checkout__switch-container-${identity}`}>
        <Tabs defaultActiveKey="link" onChange={callback} tabBarGutter={16}>
          <TabPane tab={t('checkouts.link')} key="link" />
          <TabPane tab={t('checkouts.embed')} key="embed" />
          <TabPane tab={t('checkouts.iframe')} key="iframe" />
        </Tabs>
        <Popover
          title=""
          content={t('copied')}
          trigger="click"
          visible={showPopover}
          className="detailed-checkout__popover"
        >
          <div
            className={
              activeSwitch !== 'link' ? 'detailed-checkout__link-container-embed' : `detailed-checkout__link-container detailed-checkout__link-container-${identity}`
            }
            onClick={copyHandler}
          >
            <div className={`detailed-checkout__link detailed-checkout__link-${identity}`}>
              {activeSwitch === 'link' ? (
                <p>
                  {`${checkoutLink[identity]}${
                    isRecurring ? 'recurring-payment' : type === 'SaleToken' ? 'sell-token-checkout' : 'checkout'
                  }/${isRecurring ? contractIdForLink : identifier}`}
                  <span>{`${clickIdFlag ? `?clickId=${clickIdData}` : ''}${
                    clickIdFlag && amountAndFiatCurrencyFlag ? '&' : amountAndFiatCurrencyFlag ? '?' : ''
                  }${amountAndFiatCurrencyFlag ? `amount=${amoundData}&fiatCurrency=${fiatCurrencyData}` : ''}`}</span>
                </p>
              ) : activeSwitch === 'embed' ? (
                <Highlight className="xml">{highlightedCode}</Highlight>
              ) : (
                <Highlight className="xml">{highlightedCodeIFrame}</Highlight>
              )}
            </div>
            <div className={activeSwitch !== 'link' ? 'detailed-checkout__icon-embed' : 'detailed-checkout__icon'}>
              {copyIcon[identity]}
            </div>
          </div>
        </Popover>
      </div>
      {detailedCheckoutState?.type === 'Cart' && (
        <div className="detailed-checkout__clickid-container">
          <div
            onClick={() => setAmountAndFiatCurrencyFlag(!amountAndFiatCurrencyFlag)}
            className={`detailed-checkout__clickid-container-checkbox detailed-checkout__clickid-container-checkbox-${identity}`}
          >
            <Checkbox checked={amountAndFiatCurrencyFlag} />
            <p className="detailed-checkout__clickid-container-text">{t('checkouts.amountAndFiatCurrency')}</p>
          </div>
          <Tooltip
            placement="bottomRight"
            overlayClassName="detailed-checkout__clickid-container-tooltip"
            title={t('checkouts.tooltipAmountAndFiatCurrency')}
          >
            <HelpCircleSVG />
          </Tooltip>
          {amountAndFiatCurrencyFlag && (
            <div className="detailed-checkout__clickid-container-amountAndFiatCurrencyBlock">
              <Input
                placeholder={t('checkouts.enterAmount')}
                className="detailed-checkout__clickid-container-input"
                value={amoundData}
                onChange={validateAmountData}
              />
              <Input
                placeholder={t('checkouts.enterFiatCurrency')}
                className="detailed-checkout__clickid-container-input"
                value={fiatCurrencyData}
                onChange={e => validateFiatCurrencyData(e.target.value)}
              />
            </div>
          )}
        </div>
      )}
      <div className="detailed-checkout__clickid-container">
        <div onClick={() => setClickIdFlag(!clickIdFlag)} className={`detailed-checkout__clickid-container-checkbox detailed-checkout__clickid-container-checkbox-${identity}`}>
          <Checkbox checked={clickIdFlag} />
          <p className="detailed-checkout__clickid-container-text">{t('checkouts.clickID')}</p>
        </div>
        <Tooltip
          placement="bottomRight"
          overlayClassName="detailed-checkout__clickid-container-tooltip"
          title={t('checkouts.tooltipTitle')}
        >
          <HelpCircleSVG />
        </Tooltip>
        {clickIdFlag && (
          <Input
            placeholder={t('checkouts.enterClickID')}
            className="detailed-checkout__clickid-container-input"
            value={clickIdData}
            onChange={e => validateClickId(e.target.value)}
          />
        )}
      </div>
      {AppConfig.showDomainInstruction && (
        <div className="detailed-checkout__clickid-container">
          <div
            onClick={() => (!isCustomDomain ? null : setCustomDomainFlag(!customDomainFlag))}
            className="detailed-checkout__clickid-container-checkbox"
          >
            <Checkbox checked={customDomainFlag} disabled={!isCustomDomain} />
            <p className="detailed-checkout__clickid-container-text">{t('checkouts.customDomain')}</p>
          </div>
          <Tooltip
            placement="bottomRight"
            overlayClassName="detailed-checkout__clickid-container-tooltip"
            title={
              <span>
                {t('checkouts.tooltipTitleDomain')}{' '}
                <a
                  style={{ color: '#CD081E' }}
                  href="https://app.gemewallet.com/settings"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://app.gemewallet.com/settings
                </a>
              </span>
            }
          >
            <HelpCircleSVG />
          </Tooltip>
        </div>
      )}
      {showClickIdErrorMessage && (
        <span className="detailed-checkout__clickid-container-error">{t('checkouts.validation')}</span>
      )}
      {amountAndFiatCurrencyFlag && showAmoundDataMessage && (
        <span className="detailed-checkout__clickid-container-error">{t('checkouts.validationAmountData')}</span>
      )}
      {amountAndFiatCurrencyFlag && showFiatCurrencyDataMessage && (
        <span className="detailed-checkout__clickid-container-error">{t('checkouts.validationFiatCurrencyData')}</span>
      )}
      <Button type="primary" className="detailed-checkout__button" onClick={close}>
        {t('close')}
      </Button>
    </div>
  );
};

export default DetailedCheckout;